// extracted by mini-css-extract-plugin
module.exports = {"slash":"styles_slash__AS_Dn","text_with_icon_wrapper":"styles_text_with_icon_wrapper__a_M8S","search_icon":"styles_search_icon__Ji_2i","search_text":"styles_search_text__nzPUP"};